import orderTranslationsHelper from "../../../../languages/order-translations.helper";
import planningTranslationsHelper from "../../../../languages/planning-translations.helper";
import {
  GpsCargoOrderRecordsErrorGatewayTimeout,
  GpsCargoOrderRecordsErrorType,
} from "./gps-cargo-order-records-error";

const createTimeoutError = (): GpsCargoOrderRecordsErrorGatewayTimeout => {
  const translations = orderTranslationsHelper.getActiveListingTranslations();

  return {
    message: translations.gpsGatewayTimeoutLabel,
    params: {},
    type: GpsCargoOrderRecordsErrorType.GATEWAY_TIMEOUT,
  };
};

const gpsCargoOrderRecordsErrorFactory = {
  createTimeoutError,
};

export default gpsCargoOrderRecordsErrorFactory;
